import { ConnectIntegrationModal } from 'src/redesign/pages/IntegrationsPage/components/ConnectIntegrationModal';
import { SimpleConnectionModal } from 'src/redesign/pages/IntegrationsPage/components/modals/SimpleConnectionModal';
import { AdvancedConnectedModal } from 'src/redesign/pages/IntegrationsPage/components/modals/AdvancedConnectedModal';
import { IntegrationDetailsModal } from 'src/redesign/pages/IntegrationsPage/components/modals/IntegrationDetailsModal';
import { IntegrationConfigurationModal } from 'src/redesign/pages/IntegrationsPage/components/modals/IntegrationConfigurationModal';
import { EventCancelModal } from 'src/redesign/features/EditEvent/component/EventCancelModal';
import { RemoveEventModal } from 'src/redesign/features/EditEvent/component/RemoveEventModal';
import { CancelTransferModal } from 'src/redesign/features/AttendeeEventsSidebar/components/CancelTransferModal';
import { ContactHostModal } from 'src/redesign/features/AttendeeEventsSidebar/components/ContactHostModal';
import { HostNotificationsModal } from 'src/redesign/features/Header/components/HostNotificationsModal';
import { CancelRefundRequestModal } from 'src/redesign/features/Header/components/CancelRefundRequestModal';
import { TransferRequestModal } from 'src/redesign/features/Header/components/TransferRequestModal';
import { ContactMessageModal } from 'src/redesign/features/Header/components/ContactMessageModal';
import { ZapierModal } from 'src/redesign/pages/IntegrationsPage/components/modals/ZapierModal';

export enum CONNECTED_MODALS {
  CONNECT_INTEGRATION_MODAL = 'CONNECT_INTEGRATION_MODAL',
  SIMPLE_INTEGRATION_CONNECT_MODAL = 'SIMPLE_INTEGRATION_CONNECT_MODAL',
  ADVANCED_INTEGRATION_CONNECT_MODAL = 'ADVANCED_INTEGRATION_CONNECT_MODAL',
  INTEGRATION_DETAILS_MODAL = 'INTEGRATION_DETAILS_MODAL',
  INTEGRATION_CONFIGURATION_MODAL = 'INTEGRATION_CONFIGURATION_MODAL',
  ZAPIER_MODAL = 'ZAPIER_MODAL',
  CANCEL_EVENT_MODAL = 'CANCEL_EVENT_MODAL',
  REMOVE_EVENT_MODAL = 'REMOVE_EVENT_MODAL',
  CANCEL_TRANSFER_MODAL = 'CANCEL_TRANSFER_MODAL',
  CONTACT_HOST_MODAL = 'CONTACT_HOST_MODAL',
  HOST_NOTIFICATIONS_MODAL = 'HOST_NOTIFICATIONS_MODAL',
  CANCEL_REFUND_REQUEST_MODAL = 'CANCEL_REFUND_REQUEST_MODAL',
  TRANSFER_REQUEST_MODAL = 'TRANSFER_REQUEST_MODAL',
  CONTACT_MESSAGE_MODAL = 'CONTACT_MESSAGE_MODAL',
}

export const CONNECTED_MODALS_COMPONENTS = {
  [CONNECTED_MODALS.CONNECT_INTEGRATION_MODAL]: ConnectIntegrationModal,
  [CONNECTED_MODALS.SIMPLE_INTEGRATION_CONNECT_MODAL]: SimpleConnectionModal,
  [CONNECTED_MODALS.ADVANCED_INTEGRATION_CONNECT_MODAL]: AdvancedConnectedModal,
  [CONNECTED_MODALS.INTEGRATION_DETAILS_MODAL]: IntegrationDetailsModal,
  [CONNECTED_MODALS.INTEGRATION_CONFIGURATION_MODAL]: IntegrationConfigurationModal,
  [CONNECTED_MODALS.ZAPIER_MODAL]: ZapierModal,
  [CONNECTED_MODALS.CANCEL_EVENT_MODAL]: EventCancelModal,
  [CONNECTED_MODALS.REMOVE_EVENT_MODAL]: RemoveEventModal,
  [CONNECTED_MODALS.CANCEL_TRANSFER_MODAL]: CancelTransferModal,
  [CONNECTED_MODALS.CONTACT_HOST_MODAL]: ContactHostModal,
  [CONNECTED_MODALS.HOST_NOTIFICATIONS_MODAL]: HostNotificationsModal,
  [CONNECTED_MODALS.CANCEL_REFUND_REQUEST_MODAL]: CancelRefundRequestModal,
  [CONNECTED_MODALS.TRANSFER_REQUEST_MODAL]: TransferRequestModal,
  [CONNECTED_MODALS.CONTACT_MESSAGE_MODAL]: ContactMessageModal,
};

export const FEATURE_NAME = 'modals';
